import { ApiError } from '../../api/v2/api/base/response'
import { SnackBar } from '../models/other_models'

class SnackBarState {
  isLoading: boolean = false

  snackbar: SnackBar = new SnackBar(false, '', '')
  setDefaultSnackbar() {
    this.snackbar = new SnackBar(false, '', '')
  }

  setPushSnackbar(message) {
    this.snackbar = new SnackBar(true, message, '')
  }

  async runWithLoading<T>(calc: Promise<T>, callback: {
    onError?: (error) => void,
  } = {}): Promise<T | null>{
    this.isLoading = true
    try {
      const result = await calc
      this.isLoading = false
      return result
    } catch (error) {
      this.isLoading = false
      if (error instanceof ApiError) {
        snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
      } else {
          // Noop
      }
      if (callback.onError) {
        callback.onError(error)
      }
    }

    return null
  }
}

export const snackBarState = new SnackBarState()
